<template>
    <div class="questionnaire_div">
        <h1 style="width: 80%; margin: 0 auto">测试问卷</h1>
        <div class="questionnaire_category">
            <div style="width: 70%">
                <div style="width: 80%; margin: 20px auto">
                    {{current_question['type'] === 'multi'?'多选题':'单选题'}}（{{current_question['index'] + 1}}/{{questions.length}}）<span v-html="current_question['question'] "></span>
                </div>
                <a v-for="(ans, ind) in current_question['answer']" :key="ind" class="answer-item">
                    {{String.fromCharCode(64 + parseInt(ind + 1))}}  <input type="checkbox" :checked="ans['is_select']?'checked':''" @click="set_anwser($event, ans)"/>
                    <b>
                        <span v-html="ans['content']" @click="set_anwser($event, ans)"></span>
                    </b>
                </a>
                <el-button v-if="current_question['index'] !== 0" style="margin-left: 20%" @click="prev_question()">上一题</el-button>
                <el-button v-if="current_question['index'] !== questions.length - 1" :style="current_question['index'] === 0?'margin-left: 50%':'margin-left: 20%'" @click="next_question()">下一题</el-button>
                <el-button v-if="current_question['index'] === questions.length - 1" style="margin-left: 20%" @click="complete_question()">提交</el-button>
            </div>
            <div style="width: 30%">
                <el-collapse accordion>
                    <el-collapse-item>
                        <template slot="title">
                            答题卡 （{{current_question['index'] + 1}}/{{questions.length}}）
                        </template>
                        <button :class="que['id'] === current_question['id']?'current_btn':que['is_done']?'done_btn':''" style="width: 30px; height: 30px"
                                v-for="que in questions"
                                :key="que['id']"
                                @click="click_card_btn(que)"
                        >{{que['index'] + 1}}</button>
                    </el-collapse-item>
                </el-collapse>
            </div>


        </div>

    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import ExamApi from '@/api/questionnaire/questionnaire.js'
    export default {
        data() {
            return {
                questions: [],
                current_question: {'question': '', 'id': 1, 'index': 0,'is_done':false,'type':'single', 'answer': []},
                number: this.$route.params.number,
            }
        },
        mounted: async function () {
            let that = this
            ExamApi.get_exam_question(this.number).then(function (data) {
                console.log(data)
                that.questions = data.data
                for (let i = 0; i < that.questions.length; i++) {
                    that.questions[i]['index'] = i
                }
                that.current_question = that.questions[0]
            })
        },
        methods: {
            ...mapActions({

            }),
            prev_question(){
                for (let i = 0; i < this.questions.length; i++) {
                    if (this.questions[i]['index'] === this.current_question['index'] - 1){
                        this.current_question = this.questions[i]
                    }
                }
            },
            next_question(){
                let index = -1
                this.current_question['is_done'] = true
                for (let i = 0; i < this.questions.length; i++) {
                    if (this.questions[i]['index'] === this.current_question['index'] + 1){
                        index = i
                    }
                }
                if (index !== -1){
                    this.current_question = this.questions[index]
                }
            },
            complete_question(){
                this.current_question['is_done'] = true
                console.log(this.questions)
            },
            set_anwser(event, ans){
                if (ans['is_select']){
                    ans['is_select'] = false
                }else{
                    if (this.current_question['type'] === 'single'){
                        ans['is_select'] = true
                        for (let i = 0; i < this.current_question['answer'].length; i++){
                            this.current_question['answer'][i]['is_select'] = (this.current_question['answer'][i]['id'] === ans['id'])
                        }
                    }else if (this.current_question['type'] === 'multi'){
                        ans['is_select'] = true
                    }
                }
                this.console_log_current_answer()
                this.post_current_question()
            },
            post_current_question(){
                let ids = []
                for (let i = 0; i < this.current_question['answer'].length; i++){
                    if (this.current_question['answer'][i]['is_select']){
                        ids.push(this.current_question['answer'][i]['id'])
                    }
                }
                let res ={'number': this.number, 'question_id': this.current_question['id'], 'option_ids':ids}
                ExamApi.post_exam_question(res)
            },
            click_card_btn(que){
                if (que['is_done'] && que['id'] !== this.current_question['id']){
                    let index = -1
                    for (let i = 0; i < this.questions.length; i++) {
                        if (this.questions[i]['id'] === que['id']){
                            index = i
                        }
                    }
                    if (index !== -1){
                        this.current_question = this.questions[index]
                    }
                }
            },
            console_log_current_answer(){
                let temp_list = []
                for (let i = 0; i < this.current_question['answer'].length; i++){
                    if (this.current_question['answer'][i]['is_select']){
                        temp_list.push(String.fromCharCode(64 + parseInt(i + 1)))
                    }
                }
                console.log(temp_list)
            }
        },
    }
</script>

<style scoped>
    .questionnaire_div > h1 {
        padding-left: 72px;
        color: #fff;
    }
    .questionnaire_div{
        background: url("/static/img/bg_e_1.png") no-repeat;

    }
    .questionnaire_category {
        text-align: left;
        font-size: large;
        width: 1000px;
        margin: 8px auto;
        padding: 16px 0;
        background: #fff 50%;
        min-height: 540px;
        border: #3e83c5 1px;
        border-radius: 10px;
        display: -webkit-flex;
    }
    .answer-item{
        width: 80%;
        margin: 20px auto;
        display: block
    }
    .done_btn{
        background-color: #0d86c4;
        /*float: left;*/
    }
    .current_btn{
        background-color: #58c43b;
        /*float: left;*/
    }
</style>